import React, { useEffect, useState, useRef } from 'react';
import { EnquiryTypeForm } from '../../modules/EnquiryForm/components/EnquiryTypeForm';
import { doDataLayerPush } from './EnquiryForm.helpers';
import { EnquiryFormProps } from './EnquiryForm.types';
import './EnquiryForm.scss';

export function EnquiryForm({
  type,
  formData,
  pageId,
  parentPageID,
  dropdownToDisable,
  isContactUsBlock,
  onSubmitSuccess = () => { },
  onBackClick = () => { },
}: EnquiryFormProps) {
  const successMsgRef = useRef(null);
  const [successMsg, setSuccessMsg] = useState('');

  const onFormSubmit = (data, formValues, e) => {
    if (data.success) {
      setSuccessMsg(data.message);
      doDataLayerPush(formValues, formData.Page.Title, e);
      onSubmitSuccess();
    }
  };

  useEffect(() => {
    if (successMsg && successMsgRef.current) {
      successMsgRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [successMsg]);

  // Clearing the state when page is refreshed
  window.addEventListener('beforeunload', function (event) {
    if (window.location.reload) {
      window.history.replaceState(null, '', window.location.href);
    }
  });

  if (successMsg) {
    return (
      <>
        {!isContactUsBlock && (
          <i
            className='icon-arrow-left'
            onClick={() => {
              setSuccessMsg('');
              onBackClick();
            }}
          />
        )}
        <div ref={successMsgRef} id='successMsg' className='enquiry-section-left'>
          <div
            dangerouslySetInnerHTML={{
              __html: successMsg,
            }}
          />
        </div>
      </>
    );
  }

  return (
    <div id='enqFormPage'>
      <h2 className='header-sec'>{formData?.Page?.Title || ''}</h2>
      <div className='enquiry-section'>
        {!isContactUsBlock && (
          <div className='enquiry-section-left'>
            <p>{formData?.Page?.FormDescription || ''}</p>
          </div>
        )}
        <div className='enquiry-section-right'>
          {formData && (
            <EnquiryTypeForm
              formData={formData.FormData}
              type={type}
              i18n={formData.Page}
              pageId={pageId}
              parentPageID={parentPageID}
              dropdownToDisable={dropdownToDisable}
              onFormSubmit={onFormSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
}
